import { useMemo, useState } from "react";

export function useClientPagination<Item>(items: Item[], pageSize: number) {
  const [requestedPage, setRequestedPage] = useState(0);
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
  const currentPage = Math.min(requestedPage, totalPages - 1);
  const itemsOnCurrentPage = useMemo(
    () => items.slice(currentPage * pageSize, (currentPage + 1) * pageSize),
    [items, currentPage, pageSize],
  );
  return {
    itemsOnCurrentPage,
    currentPage,
    totalPages,
    toPage: setRequestedPage,
  };
}
